import React from 'react';
import { Header } from './components/Header';
import { StartupSection } from './components/StartupSection';
import { ProjectsSection } from './components/ProjectsSection';
import { ExperienceSection } from './components/ExperienceSection';
import { EducationSection } from './components/EducationSection';
import { LeadershipSection } from './components/LeadershipSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-background-light font-sans text-text-primary" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <StartupSection data-id="element-3" />
        <ProjectsSection data-id="element-4" />
        <ExperienceSection data-id="element-5" />
        <EducationSection data-id="element-6" />
        <LeadershipSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}